import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { MtnaErrorModule, MtnaPopoverModule, MtnaTrackByPropertyPipeModule } from '@mtna/lib-ui';

import { RdsArraySomePipeModule } from '../core/pipes/array-some.pipe';
import { RdsIsFormatSelectedPipe } from './is-format-selected.pipe';
import { RdsOptionPopoverConfigPipe } from './option-popover-config.pipe';
import { RdsPackagingOptionComponent } from './packaging-option.component';
import { RdsPackagingProcessesComponent } from './packaging-processes.component';

const COMPONENTS = [RdsPackagingOptionComponent, RdsPackagingProcessesComponent];
const PIPES = [RdsOptionPopoverConfigPipe, RdsIsFormatSelectedPipe];

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    FormsModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatCheckboxModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MtnaErrorModule,
    MtnaPopoverModule,
    MtnaTrackByPropertyPipeModule,
    RdsArraySomePipeModule,
    ReactiveFormsModule,
  ],
  declarations: [COMPONENTS, PIPES],
  entryComponents: [RdsPackagingProcessesComponent],
  exports: [COMPONENTS, PIPES],
})
export class RdsPackagingModule {}
export { RdsIsFormatSelectedPipe } from './is-format-selected.pipe';
export { RdsOptionPopoverConfigPipe } from './option-popover-config.pipe';
export * from './packaging-option.component';
export * from './packaging-processes.component';
